<template>
  <v-touch
    @swipeleft="toCenter(0, 'left')"
    @swiperight="toCenter(0, 'right')"
    class="cards"
  >
    <div
      class="cards__card"
      v-for="(info, i) in cardInfo"
      :key="`card-${i}`"
      @click="toCenter(i)"
    >
      <div class="cards__content-cards">
        <img class="cards__img" :src="getImg(info.img)" />
        <div class="cards__content">
          <h3 class="cards__header">{{ info.title }}</h3>
          <a class="cards__modal-button">
            <plus-icon @click="$emit('openModal', i)"></plus-icon>
          </a>
        </div>
        <h5 class="cards__text">
          {{ info.text }}
        </h5>
      </div>
    </div>
  </v-touch>
</template>

<script>
export default {
  data() {
    return {
      cardInfo: this.$store.getters.GET_CARDS,
      openModal: false,
      currentCard: 2
    };
  },
  methods: {
    getImg: pic => require(`../../assets/img/${pic}.png`),
    toCenter(i, side) {
      if (window.innerWidth > 1200) return;
      let temp;
      if (i !== 0) {
        temp = Number(i.split('info')[1]);
      } else {
        if (side === 'right') {
          if (this.currentCard === 1) {
            temp = 3;
          } else {
            temp = this.currentCard - 1;
          }
        } else {
          if (this.currentCard === 3) {
            temp = 1;
          } else {
            temp = this.currentCard + 1;
          }
        }
        this.currentCard = temp;
      }

      document.querySelectorAll('.cards__card').forEach(v => {
        if (temp === 1) {
          v.style.transform = 'translateX(100%)';
        } else if (temp === 2) {
          v.style.transform = 'translateX(0%)';
        } else if (temp === 3) {
          v.style.transform = 'translateX(-100%)';
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cards {
  display: flex;
  justify-content: space-around;
  align-items: center;
  @include mq-max(1200px) {
    overflow: hidden;
    margin-top: 2.5rem;
    margin-top: -10rem;
    height: 75rem;
    padding-top: 5rem;
  }
  @include mq-max(991px) {
    margin-top: unset;
  }
  @include mq-max(450px) {
    height: 70rem;
    padding-top: 0;
    align-items: center;
  }
  &__card {
    background-color: $white;
    display: inline-block;
    max-width: 33.6rem;
    height: 55rem;
    border-radius: 0.8rem;
    box-shadow: 0px 16px 56px 0px rgba($black, 0.1);
    position: relative;
    font-family: Roboto;
    transition: 0.5s all ease-in-out;
    &:nth-child(even) {
      margin-top: -12rem;
      @include mq-max(1200px) {
        margin-top: unset;
        margin: 0 2.5rem;
      }
      @include mq-max(450px) {
        margin: 0 1rem;
        box-shadow: 0px 0px 16px 0px rgba($black, 0.1);
      }
    }
    @include mq-min(1201px) {
      transform: unset !important;
    }
    @include mq-max(450px) {
      margin: 0 1rem;
      max-width: 70%;
    }
  }
  &__content-cards {
    margin: 3rem;
    display: flex;
    flex-wrap: wrap;
    position: relative;
  }
  &__img {
    margin: 0 auto;
    margin-bottom: 3rem;
    height: 27.6rem;
    width: 27.2rem;
    min-width: 27.2rem;
    @include mq-max(450px) {
      height: unset;
      width: 100%;
    }
  }
  &__content {
    position: relative;
    width: 100%;
  }
  &__header {
    height: 4.8rem;
    width: 15rem;
    color: #666;
    font-size: 2.4rem;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 2.4rem;
    display: inline-block;
  }
  &__modal-button {
    cursor: pointer;
    -webkit-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    text-decoration: none;
    .material-design-icon {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateX(-50%);
    }
    svg {
      height: 4rem;
      width: 4rem;
      color: $white;
      background-color: $primary;
      font-size: 4rem;
      text-shadow: 0 4px 16px rgba($primary, 0.3);
      position: absolute;
      display: inline-block;
      right: 0;
      border-radius: 50%;
      &:hover {
        background-color: $primary-light;
      }
    }
  }
  &__text {
    height: 7.2rem;
    width: 27rem;
    color: #666;
    font-size: 2rem;
    font-weight: 300;
    line-height: 2.4rem;
    margin-top: 1rem;
    display: block;
    justify-content: left;
  }
}
</style>
